import React from "react";
import Button from "../../../../components/Button/Button";
import LangService from "../../../../services/LangService";
import { useHistory } from "react-router-dom";
import { PAGES } from "../../../../routes/PAGES";
import Block from "../Block";
import styles from "./Blocks.module.scss";

const ForthBlock = ({ block }) => {
    const langMap = LangService.map.pages.welcome;
    const history = useHistory();

    const nextPage = () => {
        gtag("event", "welcome", {
            block: block.type,
        });
        history.push(PAGES.REGISTRATION);
    };

    return (
        <Block className={styles.forthBlock}>
            {block.icon && (
                <img src={block.icon} alt={block.title} className={styles.image}/>
            )}
            {block.title && <h2>{block.title}</h2>}
            {block.buttonText && (
                <Button onClick={nextPage} style={styles.button} community rounded>
                    {block.buttonText || langMap.button}
                </Button>
            )}
        </Block>
    );
};

export default ForthBlock;
